(() => {
  if (customElements.get('pbd-preview-waiting')) return;
  class PreviewWaiting extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-waiting-card]')];
      this.index = 0;
      this.abort?.abort();
      this.abort = new AbortController();
      this.querySelector('[data-waiting-controls]').hidden = this.cards.length < 2;
      this.addEventListener('click', event => {
        const previous = event.target.closest('[data-waiting-previous]');
        const next = event.target.closest('[data-waiting-next]');
        if (!previous && !next) return;
        this.index = (this.index + (next ? 1 : -1) + this.cards.length) % this.cards.length;
        this.cards.forEach((card, index) => { card.hidden = index !== this.index; });
      }, {signal: this.abort.signal});
      this.cards.forEach((card, index) => { card.hidden = index !== 0; });
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('pbd-preview-waiting', PreviewWaiting);
})();
